import { useCallback, useState } from 'react';

import { FeatureFlagMap } from '@/providers/FeatureFlagsProvider/type';

const FeatureFlagLocalOverridesKey = 'gsb_feature_flags_overrides';

/**
 * Hook for getting feature flag overrides from local storage
 * Just put a JSON object to local storage with the key gsb_feature_flags_overrides
 * and reloads the page
 * @example
 * gsb_feature_flags_overrides => { "featureLightDarkMode": true }
 */
export const useFeatureFlagLocalOverrides = () => {
  const [overrides, setOverridesState] = useState<FeatureFlagMap>(() => {
    try {
      return JSON.parse(
        localStorage.getItem(FeatureFlagLocalOverridesKey) || '{}',
      );
    } catch (e) {
      console.warn('Failed to parse feature flag overrides', e);
      return {};
    }
  });

  const setOverrides = useCallback((newOverrides: FeatureFlagMap) => {
    try {
      localStorage.setItem(
        FeatureFlagLocalOverridesKey,
        JSON.stringify(newOverrides),
      );
      setOverridesState(newOverrides);
    } catch (e) {
      console.warn('Failed to save feature flag overrides', e);
    }
  }, []);

  return { overrides, setOverrides };
};
